module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"btn.delete":"ลบรูปภาพ","error.invalid_type":"อนุญาตเฉพาะไฟล์ที่เป็นรูปภาพเท่านั้น","error.max_file_size":"ขนาดของรูปภาพไม่ควรเกิน {size}","error.upload_error":"พบปัญหาขณะ Upload รูปภาพ : {cause}"}}')
  delete Component.options._Ctor
}
